/**
 * Intro Block JavaScript
 * Handles YouTube video modal functionality
 */

(function () {
  "use strict";

  // Initialize block functionality
  function initIntro() {
    const blocks = document.querySelectorAll(".intro");

    blocks.forEach((block) => {
      // Initialize YouTube modal functionality
      initYouTubeModal(block);
      console.log("[BLOCK] intro block initialized");
    });
  }

  /**
   * Get YouTube/Vimeo embed URL from watch URL
   */
  function getVideoEmbedUrl(url) {
    if (!url) {
      return null;
    }

    try {
      const parsed = new URL(url);
      const hostname = parsed.hostname.toLowerCase();
      const pathSegments = parsed.pathname
        .split("/")
        .filter((segment) => segment !== "");

      let videoId = null;
      let embedUrl = null;

      // Handle Vimeo URLs
      if (
        hostname.includes("vimeo.com") &&
        pathSegments.length > 0 &&
        pathSegments[0] !== "channels"
      ) {
        videoId = pathSegments[pathSegments.length - 1];
        if (videoId) {
          embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
        }
      } else if (hostname.includes("player.vimeo.com")) {
        if (pathSegments[0] === "video" && pathSegments[1]) {
          videoId = pathSegments[1];
          if (videoId) {
            embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
          }
        }
      }
      // Handle YouTube URLs
      else if (
        hostname.includes("youtube.com") ||
        hostname.includes("youtu.be")
      ) {
        // youtube.com/watch?v=VIDEO_ID
        if (parsed.searchParams.has("v")) {
          videoId = parsed.searchParams.get("v");
        }
        // youtu.be/VIDEO_ID
        else if (hostname.includes("youtu.be") && pathSegments.length > 0) {
          videoId = pathSegments[0];
        }
        // youtube.com/embed/VIDEO_ID
        else if (pathSegments[0] === "embed" && pathSegments[1]) {
          videoId = pathSegments[1];
        }
        // youtube.com/v/VIDEO_ID (legacy format)
        else if (pathSegments[0] === "v" && pathSegments[1]) {
          videoId = pathSegments[1];
        }

        if (videoId) {
          // Remove any additional parameters from video ID (e.g., ?t=123)
          videoId = videoId.split("?")[0].split("&")[0];
          embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
        }
      }

      return embedUrl;
    } catch (error) {
      return null;
    }
  }

  /**
   * Initialize YouTube modal functionality
   */
  function initYouTubeModal(block) {
    const modal = block.querySelector("[data-intro-modal]");
    const modalContent = modal
      ? modal.querySelector("[data-intro-modal-content]")
      : null;
    const modalClose = modal
      ? modal.querySelector("[data-intro-modal-close]")
      : null;
    const modalBackdrop = modal
      ? modal.querySelector("[data-intro-modal-backdrop]")
      : null;
    const modalDialog = modal
      ? modal.querySelector(".intro-modal__dialog")
      : null;
    const videoTrigger = block.querySelector("[data-intro-video-trigger]");

    if (!modal || !modalContent || !videoTrigger) {
      console.log("[BLOCK] intro modal initialization skipped - missing elements", {
        hasModal: !!modal,
        hasModalContent: !!modalContent,
        hasVideoTrigger: !!videoTrigger
      });
      return;
    }

    let isModalOpen = false;

    const closeModal = () => {
      if (!modal || !modalContent || !isModalOpen) {
        return;
      }

      modal.classList.remove("is-active");
      modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("intro-modal-open");

      const iframe = modalContent.querySelector("iframe");
      if (iframe && iframe.parentNode === modalContent) {
        iframe.remove();
      } else {
        modalContent.innerHTML = "";
      }

      if (modalDialog) {
        modalDialog.removeAttribute("aria-label");
      }

      isModalOpen = false;
      document.removeEventListener("keydown", handleKeydown);
    };

    const handleKeydown = (event) => {
      if (event.key === "Escape") {
        closeModal();
      }
    };

    const openModal = (url, title) => {
      if (!url) {
        return;
      }

      const embedUrl = getVideoEmbedUrl(url);

      if (!embedUrl) {
        window.open(url, "_blank", "noopener");
        return;
      }

      if (!modal || !modalContent) {
        window.open(embedUrl, "_blank", "noopener");
        return;
      }

      modalContent.innerHTML = `
        <iframe
          src="${embedUrl}"
          title="${title ? title.replace(/"/g, "&quot;") : "Video player"}"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
        ></iframe>
      `;

      if (modalDialog) {
        modalDialog.setAttribute(
          "aria-label",
          title || "Video player"
        );
      }

      modal.classList.add("is-active");
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("intro-modal-open");

      isModalOpen = true;
      document.addEventListener("keydown", handleKeydown);
    };

    // Handle video trigger click
    if (videoTrigger) {
      videoTrigger.addEventListener("click", (event) => {
        event.preventDefault();
        const url = videoTrigger.getAttribute("data-video-url");
        const title = videoTrigger.getAttribute("data-video-title") || "";
        openModal(url, title);
      });
    }

    // Handle modal close
    if (modalClose) {
      modalClose.addEventListener("click", (event) => {
        event.preventDefault();
        closeModal();
      });
    }

    // Handle backdrop click
    if (modalBackdrop) {
      modalBackdrop.addEventListener("click", (event) => {
        event.preventDefault();
        closeModal();
      });
    }
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initIntro);
  } else {
    initIntro();
  }
})();
